import Vue from 'vue';
import ContactUsApp from '../Scripts/Contact/contactUsApp.vue'

new Vue({
    el:"#app",
    components: {
        ContactUsApp
    },
    data() {
        return {
            contacts: (window as any).contacts
        }
    },
    template: '<contact-us-app :contacts="contacts"></contact-us-app>'
})

document.getElementById('menu-item-contact').classList.add('current-menu-item')